import { ALBUM_PRICE_MODE } from '../../../../../../../constants/albums';

/**
 * Determines whether an AlbumFolder is "parent pay".
 *
 * @param {Object} albumFolder The AlbumFolder.
 * @returns {boolean}
 */
export const isAlbumFolderParentPay = albumFolder => {
  if (!albumFolder) {
    return false;
  }

  const hasPrice = albumFolder.price?.value > 0 && !albumFolder.is_demo;
  const isPpa =
    !!albumFolder.album_price_mode &&
    albumFolder.album_price_mode === ALBUM_PRICE_MODE.PPA_ONLY;

  return hasPrice || isPpa;
};
